// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import Formatter from '../../i18n/formatter';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Wrap = styled.div`
  width: 100%;
  padding: 0.2em 1em;
  background-color: ${theme.History.betslip.footer.backgroundColor};
  color: ${theme.History.betslip.footer.color};
  display: flex;
  justify-content: space-between;
  align-self: flex-end;

  font-size: 1em;
  box-sizing: border-box;
`;

const BetslipReference = styled.div`
  font-size: 0.73em;
`;

const BetslipDate = styled.div`
  font-size: 0.73em;
`;

type HistoryItemBetslipFooterProps = {
  className?: string;
  betslipReference: string;
  date: number | null;
};

const HistoryItemBetslipFooter = ({ className, betslipReference, date }: HistoryItemBetslipFooterProps) => {
  const formattedDate = useMemo(() => Formatter.formatDate(date, 'dateMediumReversed'), [date]);
  return (
    <Wrap className={className}>
      <BetslipReference>
        {__('Ref:')} {betslipReference[0] ?? betslipReference}
      </BetslipReference>
      <BetslipDate>{formattedDate}</BetslipDate>
    </Wrap>
  );
};

export default HistoryItemBetslipFooter;
